<template>
  <footer class="pc-footer">
    <div class="footer-box">
      <div class="left">
        <a class="logo" href="//www.gm99.com" target="_blank" />
        <p class="copyright">©Copyright 2021 www.gm99.com All Rights Reserved.</p>
      </div>
      <div class="right">
        <div>
          <i class="grade" :class="`class-${pageInfo.gameClass}`"></i>
          <p class="grade-t">{{pageInfo.classText.text1}}</p>
          <p class="grade-t">{{pageInfo.classText.text2}}</p>
          <p class="grade-t">{{pageInfo.classText.text3}}</p>
        </div>
        <p class="link-group">
          <a class="link" target="_blank" href="//service.gm99.com/about/abouts.html">關於我們</a>
          <a class="link" target="_blank" href="//service.gm99.com/about/termsofuse.html">服務條款</a>
          <a class="link" target="_blank" href="//service.gm99.com/about/cooperation.html">合作提案</a>
          <a class="link" target="_blank" href="//service.gm99.com/">客服中心</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import setFooterPlay from "../directive/footer";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["pageInfo"]),
  },
};
</script>

<style lang="scss" scoped>
$imgURL: "../assets/img/pc/";
.pc-footer {
  width: 100%;
  min-width: 1024px;
  padding: 50px 0 40px;
  box-sizing: border-box;
}
.footer-box {
  width: 1024px;
  display: block;
  margin: auto;
  position: relative;
  overflow: hidden;
}
.left {
  float: left;
}
.right {
  float: right;
}
.logo {
  background: url($imgURL + "logo.png") no-repeat center;
  width: 199px;
  height: 60px;
  display: block;
  margin-left: -25px;
}
.copyright {
  font-size: 14px;
  color: #333;
  margin: 15px auto auto;
  line-height: 150%;
}
.link-group {
  font-size: 0;
  margin-top: 19px;
  .link {
    font-size: 14px;
    color: #333;
    border-right: 1px solid #333;
    display: inline-block;
    padding: 0 10px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border: none;
    }
    &:hover {
      cursor: pointer;
      color: #fda600;
    }
  }
}

.grade {
  float: left;
}

.grade-t {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  white-space: nowrap;
  padding-left: 70px;
}

.class-12 {
  background: url($imgURL + "grade-12.png") no-repeat;
  background-size: contain;
  width: 60px;
  height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/PcFooter.vue